/* eslint-disable no-nested-ternary */
import { LoadingButton } from '@mui/lab';
import { Box, Card, Stack, Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import FormProvider from 'src/components/hook-form';
import { toastError } from 'src/utils/format-error';
import { enqueueSnackbar } from 'notistack';
import { useBoolean } from 'src/hooks/use-boolean';

import { useState, useEffect } from 'react';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { SettingType, SystemConfigKey } from 'src/type/settings';
import axios, { endpoints } from 'src/utils/axios';
import UpdatedText from 'src/components/ui-kit/updated-text';
import { getSettingUpdated } from '../../utils';

export default function SettingWaitingPrice() {
  const reload = useBoolean();
  const initialize = useBoolean(true);
  const [settings, setSettings] = useState(Array<SettingType>());

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      [SystemConfigKey.WAITING_TRANSACTION_EXPIRE_TIME]: null,
    },
  });

  const {
    handleSubmit,
    reset,
    control,
    // getValues,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    load();
  }, [reload.value]);

  const load = async () => {
    try {
      initialize.onTrue();

      const query = {
        key: `${SystemConfigKey.WAITING_TRANSACTION_EXPIRE_TIME}`,
      };
      const { data } = await axios.get<SettingType[]>(endpoints.settings.get, { params: query });

      setSettings(data);
      reset(data.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {}));
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  };

  const onSubmit = handleSubmit(async (values) => {
    try {
      const body = Object.entries(values).map(([key, value]) => ({
        key,
        value: value ? dayjs(value).toISOString() : null,
      }));
      await axios.post(endpoints.settings.createOrUpdate, { configs: body });
      enqueueSnackbar('บันทึกสำเร็จ');
      reload.onToggle();
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <LoadingContainer loading={initialize.value} sx={{ minHeight: '30vh' }} fitContent>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Card sx={{ py: 5, px: 3 }}>
          <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h6">เวลาหมดอายุของระบบตั้งเวลาเป้าหมาย</Typography>
              <Typography variant="caption" color="text.secondary">
                <UpdatedText
                  {...getSettingUpdated(settings, SystemConfigKey.WAITING_TRANSACTION_EXPIRE_TIME)}
                />
              </Typography>
            </Stack>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
              <Controller
                name={SystemConfigKey.WAITING_TRANSACTION_EXPIRE_TIME}
                control={control}
                render={({ field }) => (
                  <TimePicker
                    {...field}
                    label="เลือกเวลา"
                    value={field.value ? dayjs(field.value) : null}
                    onChange={(newValue) => field.onChange(newValue)}
                    sx={{ width: 1, maxWidth: '250px' }}
                  />
                )}
              />
            </LocalizationProvider>

            <Box sx={{ mt: 2 }}>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={isSubmitting}
                sx={{ minWidth: 120 }}
              >
                บันทึก
              </LoadingButton>
            </Box>
          </Stack>
        </Card>
      </FormProvider>
    </LoadingContainer>
  );
}
